import { UUID } from "../generic/uuid";
import { CountryModel, createCountryDtoFromAdminCountryModel } from "./country";
import { ImageModel } from "./image";
import { RegionDto } from "@vini-wine/core-dtos";

export interface RegionModel extends UUID {
  // default includes
  country: CountryModel;

  // available includes
  mappedItems?: any;
  parentRegion?: RegionModel | null;
  subRegions?: RegionModel[];
  images?: ImageModel[];

  // transform
  name: string;
}

export const createRegionDtoFromAdminRegionModel = (
  region: RegionModel,
): RegionDto => {
  return {
    uuid: region.uuid,
    name: region.name,
    country: createCountryDtoFromAdminCountryModel(region.country),
  };
};
